export function getZoomIconDefaultStyles() {
    return {
        '.zmicon': {
            display: 'inline-block',
            verticalAlign: '-0.125em',
            lineHeight: 0,
        },
        '.zmicon-acc-outline': {
            outline: '2px solid #4f9af7',
        },
        '.zmicon-acc-no-outline': {
            outline: 'none',
        },
    };
}
